import { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Container,
  Form,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
  FormFeedback,
} from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import {
  useCreateFormationPro,
  useDeleteFormationPro,
  useFormationPros,
  useUpdateFormationPro,
} from "../../hooks/useFormationPros";
// import { red } from "@material-ui/core/colors";

const FormationPro = (props) => {
  const formationProsQ = useFormationPros();
  const createMutation = useCreateFormationPro();
  const updateMutation = useUpdateFormationPro();
  const deleteMutation = useDeleteFormationPro();

  const rawPros = formationProsQ.data || [];
  const formationproList = Array.isArray(rawPros)
    ? rawPros
    : rawPros?.results ?? [];

  const [selectedFormation, setSelectedFormation] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const errorMessage =
    typeof formationProsQ.error === "string"
      ? formationProsQ.error
      : formationProsQ.error?.message || "Erreur";

  const onClickDelete = useCallback((formationItem) => {
    setSelectedFormation(formationItem);
    setDeleteModal(true);
  }, []);

  const handleDeleteFormation = () => {
    if (!selectedFormation?.id) return;
    deleteMutation.mutate(selectedFormation.id, {
      onSettled: () => setDeleteModal(false),
    });
  };

  const [modal, setModal] = useState(false);
  const [type, setType] = useState({});

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setType({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const [dele, setDele] = useState(0);
  // Displat Delete Button
  const displayDelete = useCallback(() => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  }, []);

  // Delete Multiple
  const deleteMultiple = async () => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");

    const ids = Array.from(ele)
      .map((e) => e?.value)
      .filter(Boolean);

    try {
      await Promise.all(ids.map((id) => deleteMutation.mutateAsync(id)));
    } catch (_) {
      // handled by toast
    } finally {
      del.style.display = "none";
      setDele(0);
      const checkall = document.getElementById("checkBoxAll");
      if (checkall) checkall.checked = false;
      const all = document.querySelectorAll(".entrepriseCheckBox");
      all.forEach((e) => {
        e.checked = false;
      });
    }
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      label: (type && type.label) || " ",
    },

    validationSchema: Yup.object().shape({
      label: Yup.string().required(props.t("Entrer une formation pro")),
    }),

    onSubmit: async (values) => {
      if (isEdit === false) {
        const newCategory = {
          label: values.label,
        };

        var count = 0;
        if (newCategory) {
          for (let i = 0; i < formationproList.length; i++) {
            if (newCategory.label === formationproList[i]?.label) {
              count = count + 1;
              toast.error(props.t("La formation existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (count === 0) {
            try {
              await createMutation.mutateAsync(newCategory);
              validation.resetForm();
              setModal(false);
            } catch (_) {
              // handled by toast
            }
          } else {
            count = 0;
          }
        }
      } else {
        const updateCategory = {
          id: type && type.id,
          label: values.label,
        };
        var compte = 0;
        if (updateCategory) {
          for (let i = 0; i < formationproList.length; i++) {
            if (updateCategory.label === formationproList[i]?.label) {
              compte = compte + 1;
              toast.error(props.t("La formation existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (compte === 0) {
            try {
              await updateMutation.mutateAsync({
                id: updateCategory.id,
                payload: updateCategory,
              });
              validation.resetForm();
              setModal(false);
            } catch (_) {
              // handled by toast
            }
          } else {
            compte = 0;
          }
        }
      }
    },
  });

  const handleContactClick = useCallback(
    (arg) => {
      setType({
        id: arg.id,
        label: arg.label,
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }

    displayDelete();
  }, [displayDelete]);
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
              onClick={() => displayDelete()}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("FORMATION PRO"),
        accessor: "label",
        Cell: (fonctions) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link to="/functions" className="text-dark">
                    {" "}
                    {fonctions.row.original.label}
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const formationproData = cellProps.row.original;
          return (
            <>
              <li className="list-inline-item" title={props.t("Modifier")}>
                <button
                  type="button"
                  className="text-warning d-inline-block me-2 btn btn-link p-0 border-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleContactClick(formationproData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </button>
              </li>
              <Link
                to="#"
                className="text-danger d-inline-block"
                onClick={() => onClickDelete(formationproData)}
              >
                <i className="ri-delete-bin-5-line align-middle text-danger"></i>
              </Link>
            </>
          );
        },
      },
    ],
    [props, handleContactClick, checkedAll, displayDelete, onClickDelete]
  );

  document.title = props.t("Liste des formations professionnelles");

  if (formationProsQ.isLoading) return <Loader />;
  if (formationProsQ.isError) return <Loader error={errorMessage} />;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFormation}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Formations")}
          pageTitle={props.t("Formations")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-header border-0">
                  <Row className="g-4 align-items-center">
                    <Col sm={5}>
                      <div className="search-box">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder="Rechercher..."
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                    <div className="col-sm-auto ms-auto">
                      <div>
                        <button
                          className="btn btn-warning"
                          onClick={() => {
                            setModal(true);
                            setIsEdit(false);
                          }}
                        >
                          <i className="ri-add-fill align-bottom me-1"></i>{" "}
                          Ajouter une formation pro
                        </button>
                      </div>
                    </div>
                  </Row>
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {dele}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <Modal
                    id="showModal1"
                    isOpen={modal}
                    toggle={toggle}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3" toggle={toggle}>
                      {!!isEdit
                        ? props.t("Modifier une formation")
                        : props.t("Ajouter une formation")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div>
                              <Label htmlFor="" className="form-label">
                                {props.t("Nom")}
                              </Label>
                              <Input
                                name="label"
                                id="label"
                                className="form-control"
                                placeholder={props.t("Entrez le nom")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.label || ""}
                                invalid={
                                  validation.touched.label &&
                                  validation.errors.label
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.label &&
                              validation.errors.label ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.label}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            {" "}
                            {props.t("Fermer")}{" "}
                          </button>
                          <button type="submit" className="btn btn-warning">
                            {" "}
                            {!!isEdit
                              ? props.t("Modifier")
                              : props.t("Ajouter")}{" "}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  {formationproList && formationproList.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={formationproList || []}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle "
                      theadClass="table-light text-muted"
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5> {props.t("Désolé, pas de resultats trouvés")} </h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
FormationPro.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(FormationPro));
